import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const blockMembers = async (memberId) => {
  return await axios.put(`members/${memberId}/block`)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default blockMembers;